<template>
  <div class="row">
    <div class="col-12 col-lg-10 c g" v-if="file._id">
        <div class="card">
            <div class="card-header">
                <h4>
                    {{ file.title }}
                </h4>
                <h4 class="text-success">
                    الإنجاز
                    {{ percent() }}%
                </h4>
            </div>
            <div class="card-body">
                <div class="g">
                    <strong>مدير المدرسة:</strong>
                    <span v-if="!editAdminView">
                        {{ file.school_admin }}
                        <button class="btn btn-sm btn-outline-primary" style="padding: 2px 8px; margin-right: 5px" @click="editAdminName = file.school_admin; editAdminView = true">
                            <i class="fa fa-pencil"></i>
                            تعديل
                        </button>
                    </span>
                    <span v-if="editAdminView">
                        <input type="text" class="form-control form-control-sm d-inline-block" style="max-width: 250px" v-model="editAdminName" placeholder="اسم المدير...">
                        <button class="btn btn-sm btn-success" style="padding: 2px 8px" @click="saveAdminName()">
                            <i class="fa fa-check"></i>
                            حفظ
                        </button>
                        <button class="btn btn-sm btn-secondary" style="padding: 2px 8px" @click="editAdminView = false">
                            إلغاء
                        </button>
                    </span>
                </div>
                <br>
                {{ done() }} من {{ file.items.length }} مكتملة
                <div class="progress" style="border-radius: 2px">
                    <div class="progress-bar bg-success" role="progressbar" :style="`width: ${percent()}%; border-radius: 2px`"
                        :aria-valuenow="percent()" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </div>
        </div>
        <div class="col-12 text-center" >
            <button class="btn btn-success" @click="save(true);">
                <i class="fa fa-save"></i>
                حفظ التعديلات
            </button>&nbsp;
            <button class="btn btn-warning" @click="loadingpdf = true; pdf()" v-if="!loadingpdf">
                <i class="fa fa-file"></i>
                تصدير الى PDF
            </button>
            <button class="btn btn-warning" v-if="loadingpdf">
                جاري التصدير...
            </button>
            &nbsp;
            <a target="_blank" :href="`/pdfs/${file.type}.pdf`" class="btn btn-info" style="background: #0BA6DF !important; border: #6D94C5" >
                <i class="fa fa-file-pdf-o"></i>
                تحميل الدليل
            </a>
            &nbsp;
            <button class="btn btn-info" style="background: #6D94C5 !important; border: #6D94C5" v-b-modal.share v-if="user.tahdir_user_id == '' || user.subscribed" @click="short()">
                <i class="fa fa-link"></i>
                رابط الملف للمدير
            </button>
            &nbsp;
            <button class="btn" :class="file.teacher_signature ? 'btn-success' : 'btn-dark'" v-b-modal.signTeacher>
                <i class="fa fa-pencil"></i>
                {{ file.teacher_signature ? 'التوقيع محفوظ (تعديل)' : 'توقيع الملف' }}
            </button>
            <br><br>
        </div>
        <div v-if="file.teacher_signature || file.admin_signature" class="card card-body g">
            <h5 class="text-center">التوقيعات</h5>
            <div class="row">
                <div class="col-6 text-center">
                    <h6 class="text-primary">توقيع المعلم</h6>
                    <img v-if="file.teacher_signature" :src="file.teacher_signature" style="max-width: 100%; max-height: 120px; border: 1px dashed #999; border-radius: 6px; padding: 5px; background: #fff">
                    <div v-else class="text-muted"><small>لم يتم التوقيع بعد</small></div>
                    <div v-if="file.teacher_signed_at"><small class="text-muted">{{ file.teacher_signed_at }}</small></div>
                </div>
                <div class="col-6 text-center">
                    <h6 class="text-primary">توقيع مدير المدرسة</h6>
                    <img v-if="file.admin_signature" :src="file.admin_signature" style="max-width: 100%; max-height: 120px; border: 1px dashed #999; border-radius: 6px; padding: 5px; background: #fff">
                    <div v-else class="text-muted"><small>لم يتم التوقيع بعد</small></div>
                    <div v-if="file.admin_signed_at"><small class="text-muted">{{ file.admin_signed_at }}</small></div>
                </div>
            </div>
        </div>
        <div class="card card-body">
            <div v-for="item in file.items" :key="item.id" class="itemm g border-bottom hoverx" v-b-modal.item @click="selectedItem=item; addView = false; checkManual()">
                <h5>{{ `${isDoneItem(item) ? '🟢' : '🟡'} ` + item.title + (item.admin_percent == 0 ? "" : ` [حصلت على ${item.admin_percent} من ${item.percent}]` ) }}
                    <span v-if="item.admin_notes && item.admin_notes != ''"><br><br>التغذية الراجعة: {{item.admin_notes}}</span>
                </h5>
            </div>
        </div>
        <div class="col-12 text-center">
            <a href="javascript:;" v-if="!OTPDone" class="text-danger" @click="sendOTP()" v-b-modal.OTP>
                <i class="fa fa-trash"></i>
                حذف الملف
            </a>
            <a href="javascript:;" v-if="OTPDone" class="text-danger" @click="deleteFile()">
                <i class="fa fa-trash"></i>
                حذف الملف
            </a>
            <br><br>
        </div>
    </div>
    <b-modal id="share" title="مشاركة الملف" hide-footer>
        <div class="alert alert-warning text-center text-dark g">
            انتباه: هذا الرابط سري لا تشاركه مع أحد سوى المدير.
        </div>
        <div class="form-group">
          <h5 for="">رابط المشاركة</h5>
          <input type="text"
            class="form-control bg-white text-center" id="tt" @click="tt()" dir="ltr" :value="link" readonly>
        </div>
        <div class="alert alert-success text-center g" v-if="ddone">
            تم النسخ بنجاح
        </div>
        <div class="col-12 text-center g">
            <button class="btn btn-success" v-if="!viewPhone" @click="viewPhone=true;">
                <i class="fa fa-whatsapp"></i>
                ارسال للمدير عبر الواتسآب<br><small>عبر رقم النظام</small>
            </button>
            <div class="form-group" v-if="viewPhone">
              <h5 for="">رقم جوال المدير (يكون عليه واتسآب)</h5>
              <input type="number"
                class="form-control form-control-lg" v-model="phone" placeholder="الجوال هنا...">
            </div>
            <button class="btn btn-success" @click="sendNow()" v-if="viewPhone">
                إرسال الآن
            </button>
        </div>
    </b-modal>
    <b-modal id="signTeacher" title="توقيع المعلم" hide-footer size="lg" @shown="onSignShown">
        <div class="alert alert-info text-center">
            وقّع باستخدام إصبعك (على الجوال) أو الماوس في المربع أدناه.
        </div>
        <SignaturePad ref="sigPad"></SignaturePad>
        <div class="col-12 text-center g">
            <hr>
            <button class="btn btn-success" @click="saveSignature()" :disabled="savingSig">
                <i class="fa fa-save"></i>
                {{ savingSig ? 'جاري الحفظ...' : 'حفظ التوقيع' }}
            </button>
        </div>
    </b-modal>
    <b-modal id="OTP" title="تأكيد الحذف" hide-footer>
        <template v-if="!OTPSent">
            <div class="alert alert-info text-center g">
                جاري التحميل...
            </div>
        </template>
        <template v-if="OTPSent && !OTPDone">
            <div class="alert alert-success text-center g">
                تم إرسال كود على رقم الواتسآب لتأكيد الحذف
            </div>
            <div class="form-group">
            <h5 for="">كود التأكيد</h5>
            <input type="number" style="border: 1px solid #333"
                class="form-control form-control-lg" v-model="OTP" placeholder="الكود هنا...">
            </div>
            <div class="col-12 text-center">
                <button class="btn btn-success" @click="checkOTP()">
                    التأكد من الكود
                </button>
            </div>
        </template>
    </b-modal>
    <b-modal id="item" :title="selectedItem.title" hide-footer>
        <small class="alert alert-default">
            الشواهد: <span v-for="(i, c) in selectedItem.witness" :key="i">{{ i }}{{ c == selectedItem.witness.length -1 ? '.' : '، ' }}</span>
        </small>
        <br><br>
        <button class="btn btn-block btn-danger" v-if="!addView" @click="addView = true;">
            <i class="fa fa-plus"></i>
            إضاف شاهد جديد
        </button>
        <div class="col-12" v-if="addView">
            <div class="g" style="border: 1px solid #333; border-radius: 5px; width: 100%">
                <div class="form-group" v-if="!manual">
                <h5 for="">اختر الشاهد <button @click="manual=true" class="btn btn-sm btn-success" style="padding: 5px">
                    <i class="fa fa-plus"></i> كتابة يدوياً</button></h5>
                <select class="form-control form-control-lg" v-model="selectedTask">
                    <option :value="{}">-- اختر --</option>
                    <option v-for="t in selectedItem.tasks" :value="t" :key="t.title">
                        {{ t.title }}
                    </option>
                </select>
                </div>
                <div class="form-group" v-if="manual">
                  <h5 for="">اسم الشاهد</h5>
                  <input type="text"
                    class="form-control form-control-lg" v-model="manual_title" placeholder="اكتب هنا...">
                </div>
                <div class="col-12 text-center">
                    <button class="btn btn-primary" @click="addTaskNow()">إضافة الشاهد</button>
                </div>
            </div>
        </div>
        <template v-for="task in selectedItem.tasks">
            <div v-if="task.selected" :key="task.title" class="card-footer" style="margin-top: 10px; border: 1px solid #333; border-radius: 10px">
                <h5>
                    {{ task.title }}
                </h5>
                <br>
                <h5>
                    حالة التنفيذ:
                </h5>
                <div class="row">
                    <div class="col-6">
                        <button @click="task.status = 1" :class="`btn ${task.status == 1 ? 'btn-success' : 'btn-outline-success'} btn-block`">
                            <i class="fa fa-check"></i>
                            تم
                        </button>
                    </div>
                    <div class="col-6">
                        <button @click="task.status = 0" :class="`btn ${task.status == 1 ? 'btn-outline-warning' : 'btn-warning'} btn-block`">
                            <i class="fa fa-clock-o"></i>
                            لم يتم
                        </button>
                    </div>
                </div>
                <br>
                <div class="form-group">
                  <h5 for="">وصف تفصيلي للمهمة</h5>
                  <textarea class="form-control form-control-lg" v-model="task.content" placeholder="اكتب هنا..." rows="3"></textarea>
                </div>
                <div class="card-header" style="padding: 10px">
                    <i class="fa fa-image"></i>
                    الصور <small class="text-muted">(حد أقصى 5 صور في المرة)</small>
                    <input type="file" style="display:none" @change="uploadImages()" accept="image/*" multiple id="ingredient_file" />
                    <button class="btn btn-sm btn-primary float-right" @click="xtask = task; uploadImageClick()" :disabled="uploadingImage">
                        <i class="fa fa-plus"></i>
                        إضافة صور
                    </button>
                </div>
                <div class="card-footer" style="padding: 10px">
                    <div class="row">
                        <div class="col-12 text-center g" v-if="uploadingImage">
                            <div class="alert alert-info" style="margin: 0">
                                <i class="fa fa-spinner fa-spin"></i>
                                جاري رفع الصور ({{ uploadedCount }} من {{ totalToUpload }})...
                            </div>
                        </div>
                        <div class="col-6" style="padding: 2px; position: relative;" v-for="image in task.files" :key="image">
                            <button @click="deleteImage(task, image)" class="btn btn-sm btn-danger" style="padding: 5px; position: absolute; top: 0px; left: 0px">
                                <i class="fa fa-trash"></i>
                            </button>
                             <a :href="image" target="_blank"><img style="width: 100%; border-radius: 5px; border: 1px solid #333" :src="image"></a>
                        </div>
                    </div>
                 <div class="col-12 text-center">
                    <br>
                    <a v-b-modal.OTP v-if="!OTPDone" href="javascript:;" class="text-danger" @click="sendOTP()">
                        <i class="fa fa-trash"></i>
                        حذف الشاهد
                    </a>
                    <a v-if="OTPDone" href="javascript:;" class="text-danger" @click="deletetask(task)">
                        <i class="fa fa-trash"></i>
                        حذف الشاهد
                    </a>
                </div>
                </div>
            </div>
        </template>
        <div class="col-12 text-center">
            <hr>
            <button class="btn btn-success" @click="dd()">
                حفظ التعديلات
            </button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal } from "bootstrap-vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import Ripple from "vue-ripple-directive";
import SignaturePad from "@/components/SignaturePad.vue";
export default {
    components: {
        AppCollapse,
        AppCollapseItem,
        BModal,
        SignaturePad,
    },
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
    data(){
        return {
            selectedTask: {},
            link: "",
            user: JSON.parse(localStorage.getItem("user")),
            file: {},
            addView: true,
            selectedItem: {},
            manual_title: "",
            phone: "",
            OTPSent: false,
            OTPDone: false,
            OTP: "",
            OTPError: false,
            viewPhone: false,
            ddone: false,
            xtask: {},
            interval: null,
            loadingpdf: false,
            uploadingImage: false,
            viewSave: false,
            manual: false,
            lastt: null,
            editAdminView: false,
            editAdminName: "",
            uploadedCount: 0,
            totalToUpload: 0,
            savingSig: false
        }
    },
    created(){
        var g = this;
        this.gett()
        g.interval = setInterval(function(){
            if(g.file._id){
                if(!g.lastt){
                    g.lastt = JSON.stringify(g.file)
                }
                if(g.lastt != JSON.stringify(g.file)){
                    g.lastt = JSON.stringify(g.file)
                    g.viewSave = true;
                    g.save(false)
                }
            }
        }, 100)
        console.log(g.user)
    },
    beforeDestroy(){
        if(this.interval){
            clearInterval(this.interval)
        }
    },
    methods: {
        checkManual(){
            if(this.file.type == '1' || this.file.type == '6'){
                this.manual = false;
            }else{
                this.manual = true
            }
        },
        tt(){
            const input = document.getElementById("tt");
            input.focus();
            input.select();
            document.execCommand('copy');
            this.ddone = true;
            var g = this;
            setTimeout(() => {
                g.ddone = false;
            }, 3000);
        },
        checkOTP(){
            var g = this;
            $.post(api + '/user/files/check-otp', {
                jwt: g.user.jwt,
                code: g.OTP,
                id: window.location.href.split("/file/")[1].split("#")[0]
            }).then(function(r){
                if(r.status != 100){return alert("الكود غير صحيح", 200)}
                g.OTPDone = true;
                $("#OTP___BV_modal_header_ > button").click()
            }).fail(function(){
                alert('تعذر الاتصال بالخادم.', 200)
            })
        },
        short(){
            var g = this;
            $.post(api + '/user/files/short', {
                jwt: g.user.jwt,
                id: window.location.href.split("/file/")[1].split("#")[0]
            }).then(function(r){
                if(r.status != 100){return alert(r.response, 200)}
                g.link = r.response;
            }).fail(function(){
                alert('تعذر الاتصال بالخادم عند محاولة حفظ التعديلات.', 200)
            })
        },
        sendOTP(){
            var g = this;
            if(!g.OTPSent){
                $.post(api + '/user/files/delete-otp', {
                    jwt: g.user.jwt,
                    id: window.location.href.split("/file/")[1].split("#")[0]
                }).then(function(r){
                    if(r.status != 100){return alert(r.response, 200)}
                    g.OTPSent = true;
                }).fail(function(){
                    alert('تعذر الاتصال بالخادم.', 200)
                })
            }
        },
        pdf(){
            var g = this;
            $.post(api + '/user/files/pdf', {
                jwt: g.user.jwt,
                id: window.location.href.split("/file/")[1].split("#")[0]
            }).then(function(r){
                if(r.status != 100){return alert(r.response, 200)}
                window.location = r.response
            }).fail(function(){
                alert('تعذر الاتصال بالخادم عند محاولة حفظ التعديلات.', 200)
            })
        },
        dd(){
            $("#item___BV_modal_header_ > button").click()
        },
        deletetask(task){
            if(confirm("متأكد من حذف الشاهد؟")){
                task.deletedate = new Date().toISOString()
                return task.selected = false
            }
        },
        saveAdminName(){
            var g = this;
            if(!g.editAdminName || g.editAdminName.trim() == ""){
                return alert("قم بكتابة اسم مدير المدرسة", 200)
            }
            $.post(api + '/user/files/update-admin', {
                jwt: g.user.jwt,
                id: window.location.href.split("/file/")[1].split("#")[0],
                school_admin: g.editAdminName.trim()
            }).then(function(r){
                if(r.status != 100){return alert(r.response, 200)}
                g.file.school_admin = g.editAdminName.trim();
                g.editAdminView = false;
                alert("تم تحديث اسم مدير المدرسة", 100)
            }).fail(function(){
                alert('تعذر الاتصال بالخادم.', 200)
            })
        },
        save(send){
            var g = this;
            $.post(api + '/user/files/save', {
                jwt: g.user.jwt,
                id: window.location.href.split("/file/")[1].split("#")[0],
                value: JSON.stringify(g.file.items)
            }).then(function(r){
                if(r.status != 100){return alert(r.response, 200)}
                if(send){
                    alert("تم الحفظ بنجاح", 100)
                }
            }).fail(function(){
                alert('تعذر الاتصال بالخادم عند محاولة حفظ التعديلات.', 200)
            })
        },
        deleteImage(task, image){
            if(confirm('متأكد من حذف الصورة؟')){
                return task.files = task.files.filter(function(x){return x==image ? false : image})
            }
        },
        deleteFile(){
            var g = this;
            if(confirm("متأكد من حذف الملف كله نهائياً؟")){
                $.post(api + '/user/files/delete', {
                    jwt: g.user.jwt,
                    id: window.location.href.split("/file/")[1].split("#")[0],
                }).then(function(r){
                    if(r.status != 100){return alert(r.response, 200)}
                    g.$router.push('/list')
                }).fail(function(){
                    alert('تعذر الاتصال بالخادم عند محاولة حفظ التعديلات.', 200)
                })
            }
        },
        uploadImages(){
            var g = this;
            var taskxx = g.xtask;
            var inputEl = $("#ingredient_file")[0];
            var files = inputEl.files;
            if(!files || !files.length){ return; }

            var maxFiles = 5;
            var selectedFiles = Array.prototype.slice.call(files, 0, maxFiles);
            if(files.length > maxFiles){
                alert("الحد الأقصى " + maxFiles + " صور في المرة. سيتم رفع أول " + maxFiles + " فقط.", 200);
            }

            g.uploadingImage = true;
            g.totalToUpload = selectedFiles.length;
            g.uploadedCount = 0;

            var uploadOne = function(file){
                return new Promise(function(resolve){
                    var formData = new FormData();
                    formData.append("file", file, file.name);
                    formData.append("jwt", g.user.jwt);
                    $.ajax({
                        type: "POST",
                        url: api + '/user/web/upload',
                        data: formData,
                        cache: false,
                        contentType: false,
                        processData: false,
                        timeout: 120000,
                        success: function(data){
                            if(data.status == 100){
                                taskxx.files.push(data.response);
                            }
                            resolve(data.status == 100);
                        },
                        error: function(){ resolve(false); }
                    });
                });
            };

            var runSerial = async function(){
                var failures = 0;
                for(var i = 0; i < selectedFiles.length; i++){
                    var ok = await uploadOne(selectedFiles[i]);
                    if(!ok){ failures++; }
                    g.uploadedCount = i + 1;
                }
                g.uploadingImage = false;
                inputEl.value = "";
                if(failures > 0){
                    alert("فشل رفع " + failures + " صورة", 200);
                }
            };
            runSerial();
        },
        uploadImageClick(){
            $("#ingredient_file").val("")
            $("#ingredient_file").click()
        },
        onSignShown(){
            var g = this;
            if(g.$refs.sigPad){
                g.$refs.sigPad.clear();
            }
        },
        saveSignature(){
            var g = this;
            if(!g.$refs.sigPad){ return; }
            var data = g.$refs.sigPad.getData();
            if(!data){
                return alert("قم بالتوقيع أولاً داخل المربع", 200);
            }
            g.savingSig = true;
            $.post(api + '/user/files/save-signature', {
                jwt: g.user.jwt,
                id: window.location.href.split("/file/")[1].split("#")[0],
                signature: data
            }).then(function(r){
                g.savingSig = false;
                if(r.status != 100){ return alert(r.response, 200); }
                g.$set(g.file, 'teacher_signature', data);
                g.$set(g.file, 'teacher_signed_at', new Date().toISOString().split("T")[0]);
                g.lastt = JSON.stringify(g.file);
                $("#signTeacher___BV_modal_header_ > button").click();
                alert("تم حفظ التوقيع بنجاح", 100);
            }).fail(function(){
                g.savingSig = false;
                alert('تعذر الاتصال بالخادم.', 200);
            });
        },
        addTaskNow(){
            var g = this;
            if(g.manual){
                if(!g.manual_title || g.manual_title == ""){
                    return alert('قم بكتابة اسم الشاهد', 200)
                }
                g.selectedItem.tasks.push({
                    title: g.manual_title,
                    status: 0,
                    selected: true,
                    manual: true,
                    content: "",
                    files: []
                })
                g.addView = false;
            }else{
                if(!g.selectedTask.title){
                    return alert('قم باختيار العنصر', 200)
                }
                g.selectedTask.selected = true;
                g.addView = false;
                g.selectedTask = {};
            }
        },
        gett(){
            var g = this;
            $.post(api + '/user/files/file', {
                jwt: g.user.jwt,
                id: window.location.href.split("/file/")[1].split("#")[0]
            }).then(function(r){
                if(r.status != 100){return alert(r.response, 200)}
                g.file = r.response
                g.link = `https://enjazfile.tahdir.net/r/${g.file._id}`;
            })
        },
        percent(){
            var g = this, t = 0;
            g.file.items.forEach(function(a){
                var d = false;
                a.tasks.forEach(function(b){
                    if(b.status == 1  && b.selected){
                        d = true;
                    }
                })
                if(d){
                    t = t + 1
                }
            })
            return new Number(((t/g.file.items.length)*100).toFixed(0));
        },
        isDoneItem(item){
            var d = false;
            item.tasks.forEach(function(a){
                if(a.status == 1  && a.selected){
                    d = true
                }
            })
            return d;
        },
        done(){
            var g = this, t = 0;
            g.file.items.forEach(function(a){
                var d = false;
                a.tasks.forEach(function(b){
                    if(b.status == 1 && b.selected){
                        d = true;
                    }
                })
                if(d){
                    t = t + 1
                }
            })
            return t;
        },
        sendNow(){
            var g = this;
            $.post(api + '/user/files/send-to-admin', {
                jwt: g.user.jwt,
                link: g.link,
                phone: g.phone
            }).then(function(r){
                if(r.status != 100){return alert(r.response, 200)}
                alert("تم الارسال بنجاح", 100)
            })
        },
        images(){
            var g = this, t = 0;
            g.file.items.forEach(function(a){
                a.tasks.forEach(function(b){
                    t = t + b.files.length
                })
            })
            return t;
        }
    }
}
</script>

<style>
.hoverx:hover{
    background: #fafafa !important;
}
</style>